import { RUSHA_STORAGE_PREFIX } from "src/platform/constants/Storage";

import debugLogger from "./debugLogger";

/**
 * Get an item from local storage
 */
export const getItem = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    debugLogger.error(`Error getting item from storage: ${key}`, error);
    return null;
  }
};

/**
 * Set an item in local storage
 */
export const setItem = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    debugLogger.error(`Error setting item in storage: ${key}`, error);
  }
};

/**
 * Remove multiple items from local storage
 */
export const removeItems = (keys: string[]): void => {
  try {
    keys.forEach((key) => localStorage.removeItem(key));
  } catch (error) {
    debugLogger.error("Error removing items from storage", error);
  }
};

/**
 * Atomically clear all Rusha-namespaced keys (rusha:*).
 * Call on logout to prevent stale org/token state across sessions.
 */
export const clearAllRushaStorage = (): void => {
  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith(RUSHA_STORAGE_PREFIX)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));
  } catch (error) {
    debugLogger.error("Error clearing Rusha storage", error);
  }
};
